import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune';
import {
  desktopDiameter,
  rotationAnimationName,
  rotationElementsClass,
  rotationWheelClass,
} from '~/actions/extraHTML/wheelOfFortune/const';
import {
  getRotatedElementsStyles,
} from '~/actions/extraHTML/wheelOfFortune/helpers';
import {
  wheelSectorClass,
  wheelSectorTextClass,
  wheelSectorTextWrapClass,
} from '~/actions/extraHTML/wheelOfFortune/html/rotationElements/sectorHTML';
import { wheelSectorsClass } from '~/actions/extraHTML/wheelOfFortune/html/rotationElements/wheelSectors';

export const rotationDesktopElementStyles = (
  prefix: string,
  wheelParams: IWheelProps
) => `
.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass} {
  position: relative;
  background-color: white;
  border-radius: 50%;
  ${getRotatedElementsStyles({
    diameter: desktopDiameter,
    wheelParams,
  })}
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass} .${wheelSectorsClass} {
  position: relative;
  top: 0;
  left: 0;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass} .${wheelSectorClass} {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  top: 0;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass} .${wheelSectorTextWrapClass} {
  width: 100%;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass} .${wheelSectorTextClass} {
  width: 33%;
  float: right;
  text-align: center;
  font-family: 'Ubuntu';
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  padding-right: 2%;
  word-break: break-all;
  hyphens: auto;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass}.${rotationWheelClass} {
  animation-iteration-count: 1;
  animation-name: ${rotationAnimationName};
  animation-fill-mode: forwards;
}
`;
